export default __webpack_public_path__ + "static/media/comp2.88041b8c.png";